module.exports = __webpack_public_path__ + "static/img/DeluxeQueenStudio4.025561f3.jpg";